import React from 'react';
import { Col, Row } from 'antd';

import { Refetch } from '@/components/ui/Refetch';
import { useGetBeraJobSummaryList } from '@/hooks';
import { PaginationFooter } from '@/components/PaginationFooter';
import { useApplicationContext } from '@/context/v1/Application/context';
import { TableList } from '@/views/Bera/_components/List/TableList';
import { FIRST_PAGE } from '@/views/Bera/constants';

import type { BeraJobSummaryListFilter } from '@/types/Bera';

interface ListProps {
	page: number;
	pageSize: number;
	filter: BeraJobSummaryListFilter;
	onPageChange: (page: number) => void;
	onPageSizeChange: (pageSize: number) => void;
}

export function List({ page, pageSize, filter, onPageChange, onPageSizeChange }: Readonly<ListProps>): JSX.Element {
	const { organization, company } = useApplicationContext();

	const listFilter = { ...filter, limit: pageSize, offset: page - FIRST_PAGE };
	const params = { organization_id: organization?.id, company_id: company?.id, filter: listFilter };
	const { data, isFetching, isError, refetch } = useGetBeraJobSummaryList(params);

	const reports = data?.rows ?? [];
	const total = data?.count ?? 0;

	function handlePageChange(nextPage: number) {
		onPageChange(nextPage);
	}

	function handleRowsPerPageChange(rows: number) {
		onPageSizeChange(rows);
	}

	if (isError) {
		return <Refetch message="Failed to load the B.E.R.A. reports." onClick={refetch} />;
	}

	return (
		<Row justify="center">
			<TableList reports={reports} loading={isFetching} />
			<Col span={24}>
				<PaginationFooter
					page={page}
					total={total}
					pageSize={pageSize}
					onPageChange={handlePageChange}
					onPageSizeChange={handleRowsPerPageChange}
				/>
			</Col>
		</Row>
	);
}
